import {BackSide} from "three";
import {useThree} from "@react-three/fiber";

export const Background = ({ backgroundColor, floorColor, withWalls, withFloor, receiveShadow,  ...rest }) => {
    const viewport = useThree((state) => state.viewport);
    const { width, height } = viewport.getCurrentViewport();
    const wallProps = {
        receiveShadow,
        color: backgroundColor,
        width,
        height: height * 2,
        posV: height,
        posH: width / 2,
    };

    return (
        <group position={[0,-0.01, 0]} {...rest}>
            {withFloor && <Floor color={floorColor} width={width} height={width} receiveShadow={receiveShadow}/>}
            {withWalls &&
                <>
                    <PlaneRight {...wallProps}/>
                    <PlaneLeft {...wallProps}/>
                    <PlaneFront {...wallProps}/>
                    <PlaneBack {...wallProps}/>
                </>
            }
        </group>
    )
};

const PlaneRight = (props) =>
    <Plane
        {...props}
        rotation={[0, -Math.PI / 2, 0]}
        position={[props.posH,props.posV,0]}
    />;
const PlaneLeft = (props) =>
    <Plane
        {...props}
        rotation={[0, Math.PI / 2, 0]}
        position={[-props.posH,props.posV,0]}
    />;
const PlaneFront = (props) =>
    <Plane
        {...props}
        rotation={[0, Math.PI, 0]}
        position={[0,props.posV,props.posH]}
    />;
const PlaneBack = (props) =>
    <RotatedPlane
        {...props}
        rotation={[0, 0, -Math.PI / 2]}
        position={[0,props.posV,-props.posH]}
    />;
const Floor = (props) => <Plane {...props} rotation={[-Math.PI / 2, 0, 0]} />;

const RotatedPlane = (props) => {
    const width = props.height;
    const height = props.width;

    return <Plane {...props} width={width} height={height} />;
};

const Plane = ({ width, height, side, color, receiveShadow = false, ...rest }) =>
    <mesh receiveShadow={receiveShadow} {...rest} >
        <planeGeometry args={[width, height]}/>
        <meshPhysicalMaterial side={side} roughness={1} color={color} />
    </mesh>
;
